const en = {
    time: "Time",
    approval: "Approval",
    expenses: "Expenses",
    tasks: "Tasks",
    reporting: "Reporting",
    overview: "Overview",
    timeline: "Timeline",
};

export default en;
